import { useCallback, useRef } from "react";

const DEFAULT_DEBOUNCE_TIME = 500;

export function useDebounce<TArgs extends any[]>(
  fn: (...args: TArgs) => void,
  debounceTime = DEFAULT_DEBOUNCE_TIME,
) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedFn = useCallback(
    (...args: TArgs) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        fn(...args);
      }, debounceTime);
    },
    [fn, debounceTime],
  );

  return debouncedFn;
}
